<p-dialog
  appendTo="body"
  [style]="{width: '80vw'}"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="visible"
  header="Import Intransit"
  (visibleChange)="dialogVisibleChange($event)"
>
<ng-template pTemplate="content">
  <div *ngIf="isSaveing" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-card>
    <div class="container">
      <div class="formgrid grid">
          <div class="field col-12">
            <p-fileUpload
              #fileUpload
              [customUpload]="true"
              (uploadHandler)="fileUploader($event)"
              chooseLabel="{{ 'Common.Button.Select' | translate }}"
              uploadLabel="{{ 'Common.Button.Import' | translate }}"
              cancelLabel="{{ 'Common.Button.Cancel' | translate }}"
              accept=".xls,.xlsx"
            ></p-fileUpload>
          </div>
      </div>
    </div>
    <div class="mt-2">
      <laas-data-table scrollHeight="40%" [selectable]="false" [value]="intransitRows" [defaultColumns]="intransitColumns"
        [loading]="isLoading" [dataKey]="'seqNo'">
        <ng-template pTemplate="caption">
          <button pButton pRipple class="ml-2" label="{{ 'Common.Button.Save' | translate }}"
            [disabled]="intransitRows.length === 0" (click)="saveBtnClick($event)"></button>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'createDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'updateDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'bookingDate'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'pickUpDate'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'completeDeliveryTime'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'etd'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'eta'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'edc'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'ata'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'atd'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'estimatedPortClearanceTime'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'actualPortClearanceTime'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'deliveryWarehouse'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: facilityOptions | replaceNullWith: '-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'forwarderName'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: forwarderOptions | replaceNullWith: '-' }}
                </div>
              </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ rowData[col.field] | replaceNullWith:'-'}}
                  </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</ng-template>
</p-dialog>
